import { Array2d, CDLLandUse } from '@cibo/core'
import { UseQueryResult } from '@tanstack/react-query'
import { createContext } from 'react'
import { SupplyShedComparisonReport } from '../../queries'

export interface SupplyShedComparisonContextProps {
  comparisonBox?: Array2d
  resourceIds?: string[]
  cashCrops: {
    getDisplayCrops(year: number): Array<CDLLandUse>
    expanded: boolean
    setExpanded(state: boolean): void
  }
  coverCrops: {
    expanded: boolean
    setExpanded(state: boolean): void
  }
  tillage: {
    expanded: boolean
    setExpanded(state: boolean): void
  }
  reportsQuery: UseQueryResult<SupplyShedComparisonReport | undefined>
  focusYear: number
  setFocusYear(year: number): void
  reportYears?: number[]
}

// @ts-ignore can create the required reportsQuery: UseQueryResult outside of an FC
export const SupplyShedComparisonContext = createContext<SupplyShedComparisonContextProps>({
  cashCrops: {
    getDisplayCrops: () => [],
    expanded: false,
    setExpanded: () => null,
  },
  coverCrops: {
    expanded: false,
    setExpanded: () => null,
  },
  tillage: {
    expanded: false,
    setExpanded: () => null,
  },
  focusYear: new Date().getFullYear(),
  setFocusYear: () => null,
})
SupplyShedComparisonContext.displayName = 'SupplyShedComparisonContext'
